export default __webpack_public_path__ + "static/media/privacyInfo.b71b3b7e.svg";